import { Box, Grid, useMediaQuery } from '@mui/material';
import MediaCarousel from './MediaCarousel';
import { DEFAULT_PRODUCT_HANDLE } from '../constants/shop';
import { getProductMedia } from './utils';
import { useEffect, useState } from 'react';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';
import { CarouselElement, ShopifyMedia, ShopifyMediaNode } from '../types/shop';
import GradientCircularProgressContainer from '../components/common/GradientCircularProgressContainer';

const isCarouselEnabled = process.env.REACT_APP_ENABLED_CHECKOUT_CAROUSEL === 'true';

export default function OrderCheckoutProductImage({ sxProps = {}, hideForMobile = true }) {
  const [productMedia, setProductMedia] = useState<CarouselElement[]>([]);
  const [loadingProductMedia, setLoadingProductMedia] = useState<boolean>(true);
  const { theme } = useThemeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const getFirstVideoSourceFrom = (nodeElement: ShopifyMediaNode) => {
    if (nodeElement.mediaContentType !== 'VIDEO') return;

    const nodeSources = nodeElement.sources;
    if (nodeSources?.length === 0) return;

    return nodeSources && nodeSources[0].url;
  };

  useEffect(() => {
    const getMediaFromShopify = async () => {
      try {
        const imageNodes = await getProductMedia(DEFAULT_PRODUCT_HANDLE);
        const decoratedElements = imageNodes.map(({ node }: ShopifyMedia, index: number) => ({
          id: node.id,
          indexPosition: index,
          isVideo: node.mediaContentType === 'VIDEO' || node.mediaContentType === 'EXTERNAL_VIDEO',
          videoURL: getFirstVideoSourceFrom(node),
          src: node.previewImage.url,
          alt: `order-pfas-test-kit-img-${node.id}`,
        }));
        setProductMedia(decoratedElements);
      } catch (error) {
        console.error('Error getting product media', error);
      } finally {
        setLoadingProductMedia(false);
      }
    };
    getMediaFromShopify();
  }, []);

  if (loadingProductMedia) {
    return <GradientCircularProgressContainer loadingMessage={'Loading images'} />;
  }

  if (isCarouselEnabled) {
    return (
      <Grid item xs={12} sm={12} md={5}>
        <MediaCarousel elements={productMedia} />
      </Grid>
    );
  }

  if (isMobile && hideForMobile) return (<></>);

  return (
    <Grid item xs={12} sm={12} md={5}
      sx={{
        padding: { xs: "0px", md: "5px" },
        paddingLeft: '0px',
      }}
    >
      <Box
        component="img"
        src="/images/Relentless-Health-PFAS-Homekit-original.webp"
        alt="order-pfas-test-kit-img"
        {...sxProps}
        sx={{ width: '100%', height: 'auto', maxWidth: 344 }}
      />
    </Grid>
  );
}
